export enum BullQueueName {
  SmsGroupScheduledMessage = "scheduled-message",

  //NOTE: Per location: GET FMS data.
  FMSSyncGetDataRepeat = "fms-sync-get-data-repeat",
  // FMSSyncGetDataParents = "fms-sync-get-data-parents",
  // FMSSyncGetDataChildren = "fms-sync-get-data-children",
  FMSSyncGetDataForLocation = "fms-sync-get-data-for-location",
  //NOTE: Per location: Process/Sync FMS Data.
  // FMSSyncLocationsParents = "fms-sync-locations-parents",
  // FMSSyncLocationsChildren = "fms-sync-locations-children",
  FMSSyncLocationData = "fms-sync-location-data",
  FMSSync = "fms-sync",
  FMSSyncLocations = "fms-sync-locations",
  FMSSyncSingleEntity = "fms-sync-single-entity",

  //NOTE: per org or loc?
  SequencesRepeat = "sequences-repeat",
  SequencesOrgs = "sequences-orgs",

  ReviewsRepeat = "reviews-repeat",
  ReviewsAutoRepliesRepeat = "reviews-auto-replies-repeat",

  CampaignUsers = "campaign-users",
  /** SMS campaigns on the Snowy bot (ENG-3114): one job per recipient → bot POST /starters/fire. */
  SnowyCampaignFire = "snowy-campaign-fire",

  RegularTasks = "regular-tasks",

  AbandonedCartDate = "abandoned-cart-date",

  CRM = "crm",

  ProcessSequenceUserEvents = "process-sequence-user-events",
  ProcessQueuedSequenceUserEventsRepeat = "process-queued-sequence-user-events-repeat",

  //NOTE: New Sequences engine (the Reconciler) — runs on the sequence-worker dyno.
  BotSequenceReconcile = "bot-sequence-reconcile",
  BotSequenceReconcileDrainRepeat = "bot-sequence-reconcile-drain-repeat",
  BotSequenceBackfill = "bot-sequence-backfill",

  //NOTE: New Sequences engine (the Scheduler) — also on the sequence-worker dyno.
  BotSequenceSchedulerTickRepeat = "bot-sequence-scheduler-tick-repeat",
  BotSequenceSchedulerRun = "bot-sequence-scheduler-run",
  BotSequenceSchedulerBookRequest = "bot-sequence-scheduler-book-request",

  //NOTE: New Sequences engine (the Dispatcher + Handler) — also on the sequence-worker dyno.
  BotSequenceDispatchRepeat = "bot-sequence-dispatch-repeat",
  BotSequenceFire = "bot-sequence-fire",
  //NOTE: New Sequences engine (the Handler's bot-side send queue, ENG-3004) — produced
  // AND consumed by the bot web dynos; "-send" distinguishes it from the dispatcher→
  // handler fire queue above. Registered in bull only so bull-board renders it.
  BotSequenceFireSend = "bot-sequence-fire-send",

  PaymentProcessing = "payment-processing",

  CCAssignmentTimeout = "cc-assignment-timeout"
}

export enum BullJobType {
  /** SMS campaigns on the Snowy bot (ENG-3114). */
  SnowyCampaignFireRecipient = "snowy-campaign-fire-recipient",
  FMSSyncGetDataRepeat = "fms-sync-get-data-repeat",
  // FMSSyncGetDataParent = "fms-sync-get-data-parent",
  // FMSSyncGetDataChild = "fms-sync-get-data-child",
  FMSSyncGetDataForLocation = "fms-sync-get-data-for-location",

  // FMSSyncLocationChild = "fms-sync-location-child",
  // FMSSyncLocationsParent = "fms-sync-locations-parent",
  FMSSyncLocationData = "fms-sync-location-data",
  FMSSyncLocations = "fms-sync-locations",

  SequencesRepeat = "sequences-repeat",
  SequencesOrgs = "sequences-orgs",
  ProcessOrgSequences = "process-org-sequences",
  ProcessOrgSequence = "process-org-sequence",

  ReviewsRepeat = "reviews-repeat",
  ReviewsAutoRepliesRepeat = "reviews-auto-replies-repeat",

  CampaignUsers = "campaign-users",

  RegularTasks = "regular-tasks",

  AbandonedCartDate = "abandoned-cart-date",

  CRMCalculateUserData = "crm-calculate-user-data",

  ProcessSequenceUserEvents = "process-sequence-user-events",
  ProcessQueuedSequenceUserEventsRepeat = "process-queued-sequence-user-events-repeat",

  BotSequenceReconcileUser = "bot-sequence-reconcile-user",
  BotSequenceReconcileDrainRepeat = "bot-sequence-reconcile-drain-repeat",
  BotSequenceBackfillCoordinator = "bot-sequence-backfill-coordinator",
  BotSequenceBackfillChunk = "bot-sequence-backfill-chunk",

  BotSequenceSchedulerTick = "bot-sequence-scheduler-tick",
  BotSequenceSchedulerOrgRun = "bot-sequence-scheduler-org-run",
  BotSequenceSchedulerBookRequest = "bot-sequence-scheduler-book-request",

  BotSequenceDispatchRepeat = "bot-sequence-dispatch-repeat",
  BotSequenceFireAttempt = "bot-sequence-fire-attempt",
  BotSequenceFireSend = "bot-sequence-fire-send",

  CCAssignmentTimeout = "cc-assignment-timeout"
}

export enum BullEventType {
  Completed = "completed",
  Failed = "failed",
  Waiting = "waiting",
  Active = "active",
  Delayed = "delayed",
  Stalled = "stalled",
  Progress = "progress"
}

export type BullEmailTextType = {
  jobId: string;
  queue: string;
  data: any;
  returnValue?: any;
  durationMins?: number;
  failedReason?: string;
  error?: string;
};

// export const BullJobNotifyOnCompletionList = [BullJobType.FMSSyncGetDataRepeat, BullJobType.FMSSyncGetDataParent, BullJobType.FMSSyncLocationsParent];
export const BullJobNotifyOnCompletionList = [
  BullJobType.FMSSyncGetDataRepeat,
  BullJobType.FMSSyncGetDataForLocation,
  BullJobType.FMSSyncLocationData
];
